import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TitleService} from '../core/title.service';

@Component({
    selector: 'sam4-error',
    templateUrl: './error.component.html',
    styleUrls: [
        './error.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorComponent implements OnInit {

    constructor(private title: TitleService) {
    }

    ngOnInit(): void {
        this.title.set('Page not found');
    }

}
